import { render, staticRenderFns } from "./ContactsUsageAlert.vue?vue&type=template&id=236e703c&scoped=true"
import script from "./ContactsUsageAlert.vue?vue&type=script&lang=js"
export * from "./ContactsUsageAlert.vue?vue&type=script&lang=js"
import style0 from "./ContactsUsageAlert.vue?vue&type=style&index=0&id=236e703c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236e703c",
  null
  
)

export default component.exports